/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-03-09 21:58:08
* @Last Modified by:   Bolt
* @Last Modified time: 2017-03-10 15:45:47
*/

'use strict';

/**
 * 是否是新车
 * 自发新车、弹个车新车都是新车
 * carType-1 自发车新车
 * carType-3 弹个车新车
 * @Author   Bolt
 * @DateTime 2017-03-09T20:06:03+0800
 * @return   {Boolean}                [description]
 */
function isNew(item) {
    return item.carType === 1 || item.carType === 3;
}

/**
 * 是否接入了弹个车金融方案
 * consignment-1 弹个车新车有弹个车金融方案
 * secLeaseStatus-3 自发车有弹个车金融方案
 * @Author   Bolt
 * @DateTime 2017-03-09T20:08:10+0800
 * @return   {Boolean}                [description]
 */
function hasTangeche(item) {
    return item.consignment === 1 || item.secLeaseStatus === 3 || item.toolNewTangeche;
}

function supportloan(item) {
    if (!hasTangeche(item)) {
        return item.supportLoan;
    }
}

/**
 * line-height-level-0 售价、弹个车标都不显示：没有弹个车金融方案
 * line-height-level-1 弹个车标显示、售价不显示：有弹个车金融方案、无售价
 * line-height-level-2 弹个车、售价都显示：有弹个车金融方案、有售价
 * line-height-level-3 显示秒贷
 * @Author   Bolt
 * @DateTime 2017-03-09T22:02:19+0800
 * @param    {[type]}                 item [description]
 * @return   {[type]}                      [description]
 */
function getLineHeightLevel(item) {
    if (supportloan(item)) {
        return 2
    }
    if (!hasTangeche(item)) {
        return 0;
    } else if (isNew(item) || !item.price) {
        return 1;
    } else {
        return 2;
    }
}

export {
    isNew,
    hasTangeche,
    getLineHeightLevel
}



// WEBPACK FOOTER //
// ./~/@souche-f2e/wangzhan-dependencies-car-item/src/car-util.js